import React, { useEffect, useRef } from 'react';
import './testimonials.scss';
import { Container } from 'react-bootstrap';
import 'swiper/css';
import 'swiper/css/navigation';

// Switched review-widget providers (was Elfsight, now review-widget.net /
// grwapi.net) - 11 Sep 2026. Same reasoning as before still applies: a
// third-party widget's own lazy-load attribute (Elfsight's
// "data-elfsight-app-lazy") typically only defers rendering *inside* their
// platform, not the initial script download itself, so gating the <script>
// tag's own injection behind an IntersectionObserver is what actually keeps
// this off the critical path until the section is about to scroll into
// view, regardless of which vendor is behind it.
//
// Known issue with the new vendor, found by loading their live script and
// inspecting what it injects (11 Sep 2026): grwapi.net/widget.min.js adds
// its own schema.org "LocalBusiness" JSON-LD with a real aggregateRating,
// but `name: false` and `image: false` (booleans, not the strings
// schema.org expects) - almost certainly because the business name/logo
// fields are blank in the review-widget.net account dashboard. Worth
// checking that dashboard for a name/logo field to fix at the source; not
// something fixable from this file since the script builds and injects
// that JSON-LD itself, the same category of issue as the old Elfsight
// widget's self-serving/mismatched schema.
export default function TestimonialsSection() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const node = sectionRef.current;
    if (!node) return undefined;

    const loadWidget = () => {
      if (document.querySelector('script[src="https://grwapi.net/widget.min.js"]')) {
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://grwapi.net/widget.min.js';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    };

    if (!('IntersectionObserver' in window)) {
      // No IO support - fall back to loading immediately.
      loadWidget();
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          loadWidget();
          observer.disconnect();
        }
      },
      { rootMargin: '300px 0px' },
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="testimonials-section" ref={sectionRef}>
      <div className="overlay">
        <Container>
          <h2 className="section-title text-center">Client Testimonials</h2>
          <div className="section-divider mx-auto"></div>
          <div className="review-widget_net" data-uuid="78e3ddd0-b5d2-41b8-a950-bb13dfb5fa44" data-template="10"
               data-lang="en" data-theme="light"></div>
        </Container>

      </div>
    </section>
  );
}
